import { SlSocialGoogle, SlSocialInstagram, SlSocialLinkedin, SlSocialReddit, SlSocialSpotify } from 'react-icons/sl'
import HeadTitle from '../layout/HeadTitle'

export default function About() {
   return (<>
      <HeadTitle title='About Us' />
      <div className="container-fluid">
         <div className="container">
            <div className="row my-5 ">
               <div className="col-12 col-md-7 my-auto slide-in-left" style={{ animationDelay: '0.5s' }}>
                  <h5 className='fw-bold fs-2'>some title</h5>
                  <p className='pe-lg-5'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Totam excepturi sint tempora voluptatem asperiores atque unde esse provident debitis, soluta fugiat non omnis fuga blanditiis voluptate voluptates ratione ea alias doloremque, beatae aut? Rem mollitia aperiam fuga nemo quibusdam possimus sunt qui repellat, maiores voluptatum magnam modi id explicabo odit, a autem vel doloremque officiis?</p>
                  <button className='btn btn-secondary'>for more info...</button>
               </div>
               <div className="col-12 col-md-4 ps-lg-5 py-5 py-md-0 slide-in-right" style={{ animationDelay: '1s' }}>
                  <img src="/img/restaurant.svg" className='img-fluid' alt="some" />
               </div>
            </div>

            <div className="row py-4 text-center slide-in-left" style={{ animationDelay: '1.5s' }}>
               <img className='img-fluid rounded-circle col-12 col-md-6 mx-auto d-block' style={{ aspectRatio: '1/1', objectFit: 'cover' }} src="/img/chef.jpg" alt="our chef" />
               <h3 >our chef:<span className='text-primary ps-2 fw-bold'>  avi ben susim</span>  </h3>
            </div>

            <div className="row my-5">
               <div className="col-12 text-center">
                  <h5 className='fw-bold'>contact us</h5>
               </div>
               <div className="col-12 d-flex justify-content-center gap-3 mt-2">
                  <button className='btn btn-primary rounded-3 fs-4'><SlSocialInstagram /></button>
                  <button className='btn btn-primary rounded-3 fs-4'><SlSocialLinkedin /></button>
                  <button className='btn btn-primary rounded-3 fs-4'><SlSocialGoogle /></button>
                  <button className='btn btn-primary rounded-3 fs-4'><SlSocialReddit /></button>
                  <button className='btn btn-primary rounded-3 fs-4'><SlSocialSpotify /></button>
               </div>
            </div>
         </div>
      </div>

   </>
   )
}
